import { parse as parseQueryString } from 'query-string';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function RouterPropsWrapper(props: { render: (p: IWithReactRouterProps) => JSX.Element }) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const routeProps = { location: { ...location, ...{ query: parseQueryString(location.search) } }, match: { params }, navigate, params } as any;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return <>{props.render(routeProps)}</>;
}

export interface IWithReactRouterProps {
    match: { params: any };
    params: any;
    location: { pathname: string; query: any };
    navigate: ReturnType<typeof useNavigate>;
}

type PropsWithoutReactRouterProps<P extends IWithReactRouterProps> = Omit<P, keyof IWithReactRouterProps>;

export function withReactRouter<OriginalProps extends IWithReactRouterProps>(
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Component: React.ComponentClass<OriginalProps>,
): React.ComponentClass<PropsWithoutReactRouterProps<OriginalProps>> {
    function ComponentWithRouterProp(props: any) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        const routeProps = { location: { ...location, ...{ query: parseQueryString(location.search) } }, match: { params }, navigate, params };
        return <Component {...props} {...routeProps} />;
    }
    return ComponentWithRouterProp as unknown as React.ComponentClass<PropsWithoutReactRouterProps<OriginalProps>>;
}
